interface BankAccountLike {
  id: string;
  loginRequired?: boolean;
}

export const doesBankNeedReAuth = (
  bankAccounts: BankAccountLike[] | null | undefined,
  bankAccountId: string | null | undefined
) => {
  if (!bankAccounts || !bankAccountId) return false;
  const bank = bankAccounts.find((b) => b.id === bankAccountId);
  return bank ? !!bank.loginRequired : false;
};
